import { Checkbox, Stack, TagsInput, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@mygpt/app';

import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { useWidgetForm } from '@/hooks/useWidgetForm';

import { SettingCard } from './SettingCard';

/** 自动打开：仅小部件（嵌入小窗）生效 */
export const WidgetAutoOpen = () => {
  const { t } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();
  const canAccessWidgetCustomization = useCanAccess('enable_widget_customization');

  return (
    <SettingCard title={t('widget.setting.groups.card_auto_open')}>
      <Stack>
        <Checkbox
          disabled={!canAccessWidgetCustomization}
          label={t('widget.setting.chatbot.auto_open_urls_label')}
          checked={form.values.chatbot.autoOpenUrls.checked}
          {...form.getInputProps('chatbot.autoOpenUrls.checked')}
          onChange={onOverrideChangeForForm('chatbot.autoOpenUrls.checked')}
        />
        <Text size="sm" c="gray.6">
          {t('widget.setting.chatbot.auto_open_urls_desc')}
        </Text>
        <TagsInput
          disabled={!canAccessWidgetCustomization || !form.values.chatbot.autoOpenUrls.checked}
          placeholder={t('widget.setting.chatbot.auto_open_urls_placeholder')}
          value={form.values.chatbot.autoOpenUrls.urls}
          onChange={(urls) => {
            form.setFieldValue('chatbot.autoOpenUrls.urls', urls);
            onOverrideChangeForForm('chatbot.autoOpenUrls.urls')({ type: 'blur', isTrusted: true });
          }}
          acceptValueOnBlur
          splitChars={[',', ' ', '|']}
          maxTags={10}
          data={[]}
          size="sm"
        />
      </Stack>
    </SettingCard>
  );
};
